var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-container"},[_c('div',{staticClass:"g-map"},[_c('GmapMap',{staticStyle:{"width":"100%","height":"400px"},attrs:{"center":_vm.center,"zoom":_vm.zoom}},[_c('GmapMarker',{attrs:{"position":_vm.markerPosition,"clickable":true,"draggable":false}})],1)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }